import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { change, Field, reduxForm } from 'redux-form';
import classNames from 'classnames';
import RaisedButton from 'material-ui/RaisedButton';
import moment from 'moment';
import _ from 'lodash';
import { getBehaviorCollactDataList, deleteBehaviorCollactData, UpdateCollectedBehaviorData } from './actions/behaviorActions';
import { renderCheckBox, renderAutoCompleteSingleSelect, renderDateField, renderTimePicker, renderTextField, isInteger, isFloat } from '../../../../../../components/reduxFields';
import { CancelButton } from '../../../../../../components/buttons';
import SmallLoader from '../../../../../../img/small-loader.gif';
import PaginatorCustom from '../../../../../../components/paginationCustom';
import SortingCustom from '../../../../../../components/SortingCustom';
import { showFormatedDateandTime } from "../../../../../../actions/utilAction";

const stylescss = {
    checkbox: {
        marginBottom: 16,
    },
};

class RawDataModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            patientId: props.patientId,
            behaviorId: props.behaviorId,
            recordingTypeName: props.recordingTypeName,
            behaviorName: props.behaviorName,
            selectedRecordDataIds: [],
            sessionDate: [],
            sessionTime: [],
        };
        this.filter = {
            sort_Column: '',
            sort_order: '',
            searchText: '',
        };
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.setSortColumn = this.setSortColumn.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.onTimeChange = this.onTimeChange.bind(this);
        this.handleValueChange = this.handleValueChange.bind(this);
    }

    componentWillMount() {
        this.loadData();
    }

    componentWillReceiveProps(nextProps) {
        let self = this;
        document.onkeydown = function (evt) {
            evt = evt || window.event;
            if (evt.keyCode === 27) {
                self.handleClose();
            }
        };

        if (this.state.recordingTypeName.toUpperCase() === "FREQUENCY" && nextProps.behaviorCollactDataListByBehaviorId && nextProps.behaviorCollactDataListByBehaviorId.data) {

            let sessionDate1 = this.state.sessionDate;
            let sessionTime1 = this.state.sessionTime;
            (nextProps.behaviorCollactDataListByBehaviorId.data || []).forEach((obj, index) => {
                _.update(sessionDate1, `[${obj.id}]`, function (n) {
                    return moment(obj.sessionDate).format('MM-DD-YYYY');
                });
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].sessionDate`, moment(obj.sessionDate).format('MM-DD-YYYY') || null));

                _.update(sessionTime1, `[${obj.id}]`, function (n) {
                    return moment(obj.sessionDate).format('YYYY-MM-DD') + 'T' + moment(obj.sessionDate).format('HH:mm:ss');
                });
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].sessionTime`, moment(obj.sessionDate).format('HH:mm:ss') || '00:00:00'));
            });
            this.setState({ sessionDate: sessionDate1, sessionTime: sessionTime1 });

            (nextProps.behaviorCollactDataListByBehaviorId.data || []).forEach((obj, index) => {
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].id`, obj.staffId || null));
            });

            (nextProps.behaviorCollactDataListByBehaviorId.data || []).forEach((obj, index) => {
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].value`, obj.value || 0));
            });
        }
        else if (this.state.recordingTypeName.toUpperCase() === "DURATION" && nextProps.behaviorCollactDataListByBehaviorId && nextProps.behaviorCollactDataListByBehaviorId.data) {

            let sessionDate1 = this.state.sessionDate;
            let sessionTime1 = this.state.sessionTime;
            (nextProps.behaviorCollactDataListByBehaviorId.data || []).forEach((obj, index) => {
                _.update(sessionDate1, `[${obj.id}]`, function (n) {
                    return moment(obj.sessionDate).format('MM-DD-YYYY');
                });
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].sessionDate`, moment(obj.sessionDate).format('MM-DD-YYYY') || null));

                _.update(sessionTime1, `[${obj.id}]`, function (n) {
                    return moment(obj.sessionDate).format('YYYY-MM-DD') + 'T' + moment(obj.sessionDate).format('HH:mm:ss');
                });
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].sessionTime`, moment(obj.sessionDate).format('HH:mm:ss') || '00:00:00'));
            });
            this.setState({ sessionDate: sessionDate1, sessionTime: sessionTime1 });

            (nextProps.behaviorCollactDataListByBehaviorId.data || []).forEach((obj, index) => {
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].id`, obj.staffId || null));
            });

            (nextProps.behaviorCollactDataListByBehaviorId.data || []).forEach((obj, index) => {
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].duration`, obj.duration || 0));
            });
        }
        else if (this.state.recordingTypeName.toUpperCase() === "RATE" && nextProps.behaviorCollactDataListByBehaviorId && nextProps.behaviorCollactDataListByBehaviorId.data) {

            let sessionDate1 = this.state.sessionDate;
            let sessionTime1 = this.state.sessionTime;
            (nextProps.behaviorCollactDataListByBehaviorId.data || []).forEach((obj, index) => {
                _.update(sessionDate1, `[${obj.id}]`, function (n) {
                    return moment(obj.sessionDate).format('MM-DD-YYYY');
                });
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].sessionDate`, moment(obj.sessionDate).format('MM-DD-YYYY') || null));

                _.update(sessionTime1, `[${obj.id}]`, function (n) {
                    return moment(obj.sessionDate).format('YYYY-MM-DD') + 'T' + moment(obj.sessionDate).format('HH:mm:ss');
                });
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].sessionTime`, moment(obj.sessionDate).format('HH:mm:ss') || '00:00:00'));
            });
            this.setState({ sessionDate: sessionDate1, sessionTime: sessionTime1 });

            (nextProps.behaviorCollactDataListByBehaviorId.data || []).forEach((obj, index) => {
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].id`, obj.staffId || null));
            });

            (nextProps.behaviorCollactDataListByBehaviorId.data || []).forEach((obj, index) => {
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].value`, obj.value || 0));
            });

            (nextProps.behaviorCollactDataListByBehaviorId.data || []).forEach((obj, index) => {
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].duration`, obj.duration || 0));
            });
        }
        else if (this.state.recordingTypeName.toUpperCase() === "PARTIAL INTERVAL" && nextProps.behaviorCollactDataListByBehaviorId && nextProps.behaviorCollactDataListByBehaviorId.data) {

            let sessionDate1 = this.state.sessionDate;
            let sessionTime1 = this.state.sessionTime;
            (nextProps.behaviorCollactDataListByBehaviorId.data || []).forEach((obj, index) => {
                _.update(sessionDate1, `[${obj.id}]`, function (n) {
                    return moment(obj.sessionDate).format('MM-DD-YYYY');
                });
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].sessionDate`, moment(obj.sessionDate).format('MM-DD-YYYY') || null));

                _.update(sessionTime1, `[${obj.id}]`, function (n) {
                    return moment(obj.sessionDate).format('YYYY-MM-DD') + 'T' + moment(obj.sessionDate).format('HH:mm:ss');
                });
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].sessionTime`, moment(obj.sessionDate).format('HH:mm:ss') || '00:00:00'));
            });
            this.setState({ sessionDate: sessionDate1, sessionTime: sessionTime1 });

            (nextProps.behaviorCollactDataListByBehaviorId.data || []).forEach((obj, index) => {
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].id`, obj.staffId || null));
            });

            (nextProps.behaviorCollactDataListByBehaviorId.data || []).forEach((obj, index) => {
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].intervalValue`, obj.intervalValue || 'No'));
            });

            (nextProps.behaviorCollactDataListByBehaviorId.data || []).forEach((obj, index) => {
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].interval`, obj.interval || 0));
            });
        }
        else if (this.state.recordingTypeName.toUpperCase() === "MOMENTARY TIME SAMPLE" && nextProps.behaviorCollactDataListByBehaviorId && nextProps.behaviorCollactDataListByBehaviorId.data) {

            let sessionDate1 = this.state.sessionDate;
            let sessionTime1 = this.state.sessionTime;
            (nextProps.behaviorCollactDataListByBehaviorId.data || []).forEach((obj, index) => {
                _.update(sessionDate1, `[${obj.id}]`, function (n) {
                    return moment(obj.sessionDate).format('MM-DD-YYYY');
                });
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].sessionDate`, moment(obj.sessionDate).format('MM-DD-YYYY') || null));

                _.update(sessionTime1, `[${obj.id}]`, function (n) {
                    return moment(obj.sessionDate).format('YYYY-MM-DD') + 'T' + moment(obj.sessionDate).format('HH:mm:ss');
                });
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].sessionTime`, moment(obj.sessionDate).format('HH:mm:ss') || '00:00:00'));
            });
            this.setState({ sessionDate: sessionDate1, sessionTime: sessionTime1 });

            (nextProps.behaviorCollactDataListByBehaviorId.data || []).forEach((obj, index) => {
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].id`, obj.staffId || null));
            });

            (nextProps.behaviorCollactDataListByBehaviorId.data || []).forEach((obj, index) => {
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].intervalValue`, obj.intervalValue || 'No'));
            });

            (nextProps.behaviorCollactDataListByBehaviorId.data || []).forEach((obj, index) => {
                this.props.dispatch(change('RawDataModalForm', `Behavior[${index}].interval`, obj.interval || 0));
            });
        }
    }

    loadData(page_number) {
        let searchObj = {
            sort_fields: this.filter.sort_Column || '',
            sort_order: this.filter.sort_order || '',
            contain_filters: {
                searchText: this.filter.searchText || null,
                patientId: this.state.patientId,
                behaviorReductionId: this.state.behaviorId,
                recordingTypeName: this.state.recordingTypeName
            },
            pageNumber: page_number || 1,
        };
        this.props.getBehaviorCollactDataList(searchObj);
    }

    setSortColumn(col_name, col_order) {
        if (col_name) {
            this.filter.sort_Column = col_name;
            this.filter.sort_order = col_order;
            this.loadData();
        }
    }


    handleSearchChange(event) {
        if (event.target.value.length > 2) {
            this.filter.searchText = event.target.value;
            this.loadData();
        } else if (event.target.value.length === 0) {
            this.filter.searchText = '';
            this.loadData();
        }
    }

    handleOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        if (this.state.open) {
            this.setState({ open: false });
            this.props.closeDialog();
        }
    };

    renderLoading() {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }


    handleDeleteBehavior = () => {
        this.props.deleteBehaviorCollactData(this.state.selectedRecordDataIds.toString(), this.state.recordingTypeName.toString(), this.state.patientId, this.state.behaviorId)
        this.setState({
            selectedRecordDataIds: []
        });
    }

    // checkAllBehaviors = (e) => {
    //     let isBehaviorChecked = e.target.checked;
    //     let tragetData = this.props.behaviorCollactDataListByBehaviorId.data !== undefined && this.props.behaviorCollactDataListByBehaviorId.data;
    //     let selectedRecordDataIds = [];
    //     tragetData.forEach((obj, index) => {
    //         let targetIdCheck = `CheckBehavior[${obj.id}${index}].Chk`;
    //         if (obj && isBehaviorChecked) {
    //             selectedRecordDataIds.push(obj.id);
    //             this.props.dispatch(change('RawDataModalForm', targetIdCheck, true));
    //         } else {
    //             this.props.dispatch(change('RawDataModalForm', targetIdCheck, false));
    //         }
    //     })
    //     this.setState({
    //         selectedRecordDataIds: selectedRecordDataIds,
    //     });
    // }

    checkBehaviors = (e, index, obj) => {
        let selectedRecordDataIds = this.state.selectedRecordDataIds;
        let isBehaviorChecked = e.target.checked;
        if (isBehaviorChecked) {
            if (obj.recordDataDetailId) {
                selectedRecordDataIds.push(obj.recordDataDetailId);
            }
        } else {
            if (obj.recordDataDetailId) {
                index = selectedRecordDataIds.findIndex((value) => value === obj.recordDataDetailId);
                if (index >= 0) {
                    selectedRecordDataIds.splice(index, 1);
                }
            }
        }
        this.setState({
            selectedRecordDataIds: selectedRecordDataIds
        });
    }
  

    handleNewRequestStatus = (input, selectedRecord, data, action) => {
        input.onChange(selectedRecord.value);
        this.props.UpdateCollectedBehaviorData(data.id, data.recordDataDetailId, moment().format('YYYY-MM-DDTHH:mm:ss'), selectedRecord.value, 0, 0.0, this.state.patientId, this.state.behaviorId, action, this.state.recordingTypeName.toUpperCase())
    };

    onDateChange = (input, value, data, action) => {
        input.onChange(moment(value).format());

        let sessionDate1 = this.state.sessionDate;

        _.update(sessionDate1, `[${data.id}]`, function (n) {
            return moment(value).format('YYYY-MM-DD');
        });

        this.setState({
            sessionDate: sessionDate1,
        }, () => {

            let sessionDate = moment(this.state.sessionDate[data.id]).format('YYYY-MM-DD') + 'T' + moment(this.state.sessionTime[data.id]).format('HH:mm:ss');
            this.props.UpdateCollectedBehaviorData(data.id, data.recordDataDetailId, sessionDate, 0, 0, 0.0, this.state.patientId, this.state.behaviorId, action, this.state.recordingTypeName.toUpperCase())
        });
    }

    onTimeChange = (input, value, data, action) => {
        input.onChange(moment(value).format());

        let sessionTime1 = this.state.sessionTime;

        _.update(sessionTime1, `[${data.id}]`, function (n) {
            return moment(value).format('YYYY-MM-DD') + 'T' + moment(value).format('HH:mm:ss');
        });

        this.setState({
            sessionTime: sessionTime1,
        }, () => {
            let sessionDate = moment(this.state.sessionDate[data.id]).format('YYYY-MM-DD') + 'T' + moment(this.state.sessionTime[data.id]).format('HH:mm:ss');
            this.props.UpdateCollectedBehaviorData(data.id, data.recordDataDetailId, sessionDate, 0, 0, 0.0, this.state.patientId, this.state.behaviorId, action, this.state.recordingTypeName.toUpperCase())
        });
    }

    handleValueChange = (event, data, action) => {
        this.props.UpdateCollectedBehaviorData(data.id, data.recordDataDetailId, moment().format('YYYY-MM-DDTHH:mm:ss'), 0, event.target.value, 0.0, this.state.patientId, this.state.behaviorId, action, this.state.recordingTypeName.toUpperCase())
    }

    handleDurationChange = (event, data, action) => {
        this.props.UpdateCollectedBehaviorData(data.id, data.recordDataDetailId, moment().format('YYYY-MM-DDTHH:mm:ss'), 0, 0, event.target.value, this.state.patientId, this.state.behaviorId, action, this.state.recordingTypeName.toUpperCase())
    }

    handleIntervalValueChange = (event, data, action) => {
        this.props.UpdateCollectedBehaviorData(data.id, data.recordDataDetailId, moment().format('YYYY-MM-DDTHH:mm:ss'), 0, (event.target.value.toUpperCase() === 'Y' ? 1 : 0), 0.0, this.state.patientId, this.state.behaviorId, action, this.state.recordingTypeName.toUpperCase())
    }

    renderaDataFrequency = (RawBehaviorDataList) => {
        RawBehaviorDataList = RawBehaviorDataList || [];

        if (!RawBehaviorDataList.length) {
            return (
                <tr>
                    <td colSpan="6">
                        <div className="text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
                    </td>
                </tr>
            );
        }
        return RawBehaviorDataList.map((data, index) => {
            return (
                <tr key={index}>
                    <td>
                        <Field
                            name={`Behavior[${index}].id`}
                            hintText="Staff Name"
                            handleNewRequest={(input, selectedValue) => this.handleNewRequestStatus(input, selectedValue, data, 'STAFFID')}
                            options={this.props.allStaffs}
                            component={renderAutoCompleteSingleSelect}
                        />
                    </td>
                    <td>
                        <Field
                            name={`Behavior[${index}].sessionDate`}
                            //placeholder="Session Date"
                            locale="en-US"
                            selected={this.state.sessionDate[data.id]}
                            onDateChange={(input, value) => this.onDateChange(input, value, data, 'SESSIONDATE')}
                            openToYearSelection={true}
                            component={renderDateField} />
                    </td>
                    <td>
                        <Field
                            name={`Behavior[${index}].sessionTime`}
                            //placeholder="Time"
                            fullWidth={true}
                            selected={this.state.sessionTime[data.id]}
                            component={renderTimePicker}
                            onDateChange={(input, value) => this.onTimeChange(input, value, data, 'SESSIONDATE')}
                        />
                    </td>
                    {this.state.recordingTypeName.toUpperCase() === "DURATION" || this.state.recordingTypeName.toUpperCase() === "RATE" ?
                        <td>
                            <Field
                                name={`Behavior[${index}].duration`}
                                type="text"
                                maxLength="5"
                                label="Duration In Min."
                                component={renderTextField}
                                normalize={isFloat}
                                onBlur={(event) => this.handleDurationChange(event, data, 'DURATION')}
                            />
                            <small>(Ex: 15 sec = 0.25 min)</small>
                        </td>
                        : null}
                     {this.state.recordingTypeName.toUpperCase() === "FREQUENCY" || this.state.recordingTypeName.toUpperCase() === "RATE" ?
                        <td>
                            <Field
                                name={`Behavior[${index}].value`}
                                type="text"
                                maxLength="2"
                                label="Value"
                                component={renderTextField}
                                normalize={isInteger}
                                onChange={(event) => this.handleValueChange(event, data, 'VALUE')}
                            />
                        </td>
                        : null}
                    {this.state.recordingTypeName.toUpperCase() === "PARTIAL INTERVAL" || this.state.recordingTypeName.toUpperCase() === "MOMENTARY TIME SAMPLE" ?
                        <td>
                            <Field
                                name={`Behavior[${index}].interval`}
                                type="text"
                                maxLength="2"
                                label="Interval"
                                component={renderTextField}
                                normalize={isInteger}
                                onBlur={(event) => this.handleDurationChange(event, data, 'INTERVAL')}
                            />
                        </td>
                        : null}
                    {this.state.recordingTypeName.toUpperCase() === "PARTIAL INTERVAL" || this.state.recordingTypeName.toUpperCase() === "MOMENTARY TIME SAMPLE" ?
                        <td>
                            <Field
                                name={`Behavior[${index}].intervalValue`}
                                type="text"
                                maxLength="3"
                                label="Value (Enter “Yes” or “No”)"
                                component={renderTextField}                               
                                onChange={(event) => this.handleIntervalValueChange(event, data, 'INTERVALVALUE')}
                            />
                        </td>
                        : null}
                    <td>
                        <div className="table_custom-check">
                            <Field
                                name={`CheckBehavior[${data.recordDataDetailId}${index}].Chk`}
                                component={renderCheckBox}
                                onChange={(e) => this.checkBehaviors(e, index, data)}
                                style={stylescss.checkbox}
                            />
                        </div>
                    </td>
                </tr>
            );
        });
    }

    render() {
        const { behaviorCollactDataListByBehaviorId } = this.props,
            RawBehaviorDataList = (behaviorCollactDataListByBehaviorId && behaviorCollactDataListByBehaviorId.data) || [],
            RawBehaviorDataListMeta = (behaviorCollactDataListByBehaviorId && behaviorCollactDataListByBehaviorId.meta) || null;
        const tableClass = classNames({
            'table': true,
            'table-striped': this.props.bordered,
            'table-bordered': this.props.bordered,
            'table-hover': true,
            'table-condensed': this.props.condensed,
            'customtable': true,
            'suptable': true,
        });
        const actions = [
            <RaisedButton
                disabled={this.state.selectedRecordDataIds.length > 0 ? false : true}
                className="mr-15"
                label="Delete Data"
                primary={true}
                onTouchTap={() => this.handleDeleteBehavior()} />,
            <CancelButton className="mr-15" onTouchTap={this.handleClose} />
        ];
        return (
            <Dialog
                className="custom_modal_new_appointment"
                title={'RAW BEHAVIOR DATA OF ' + this.state.behaviorName}
                modal={false} open={this.state.open} actions={actions} autoScrollBodyContent={true}>
                {this.renderLoading()}
                <div className="table-responsive mt-15">                    
                    <table className={tableClass}>
                        <thead>
                            <tr>
                                <th width="20%">{<SortingCustom noSort={!RawBehaviorDataList.length} setSortColumn={this.setSortColumn} columnName='staffName' displayName='Staff Name' />}</th>
                                <th width="15%">Session Date</th>
                                <th width="15%">Session Time</th>
                                {this.state.recordingTypeName.toUpperCase() === "DURATION" || this.state.recordingTypeName.toUpperCase() === "RATE" ? <th width="25%">Duration</th> : null}
                                {this.state.recordingTypeName.toUpperCase() === "PARTIAL INTERVAL" || this.state.recordingTypeName.toUpperCase() === "MOMENTARY TIME SAMPLE" ? <th width="25%">Interval #</th> : null}
                                {this.state.recordingTypeName.toUpperCase() === "FREQUENCY" || this.state.recordingTypeName.toUpperCase() === "RATE" || this.state.recordingTypeName.toUpperCase() === "PARTIAL INTERVAL" || this.state.recordingTypeName.toUpperCase() === "MOMENTARY TIME SAMPLE" ? <th width="15%">Value</th> : null}
                                <th width="10%">Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderaDataFrequency(RawBehaviorDataList)}
                        </tbody>
                    </table>
                </div>
                {RawBehaviorDataListMeta && RawBehaviorDataListMeta['totalPages'] ?
                    <PaginatorCustom data={RawBehaviorDataListMeta} handlePageChange={(page_number) => this.loadData(page_number)} />
                    : null
                }
            </Dialog>)
    }
}

RawDataModal = reduxForm({
    form: 'RawDataModalForm',
    enableReinitialize: true,
})(RawDataModal);


function mapStateToProps(state, ownProps) {
    return {
        loading: state.patient_behavior.loading,
        behaviorCollactDataListByBehaviorId: state.patient_behavior.behaviorCollactDataListByBehaviorId !== null ? state.patient_behavior.behaviorCollactDataListByBehaviorId : [],
        allStaffs: state.patient_behavior.masterData ? state.patient_behavior.masterData.allStaffsActiveAndInactive : [],
    }
}

export default connect(mapStateToProps, { getBehaviorCollactDataList, deleteBehaviorCollactData, UpdateCollectedBehaviorData })(RawDataModal);



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/Behavior/RawDataModal.js